import React, { useState, useEffect } from 'react';
import { 
  Container, 
  Typography, 
  Button, 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow, 
  Paper, 
  IconButton,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle 
} from '@mui/material';
import { Edit as EditIcon, Delete as DeleteIcon, Add as AddIcon } from '@mui/icons-material';
import axios from 'axios';

function CrudRubros() {
  const [rubros, setRubros] = useState([]);
  const [open, setOpen] = useState(false);
  const [currentRubro, setCurrentRubro] = useState(null);
  const [det_rubro, setDetRubro] = useState('');

  useEffect(() => {
    fetchRubros();
  }, []);

  const fetchRubros = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/rubros`);
      setRubros(response.data);
    } catch (error) {
      console.error('Error al obtener los rubros:', error);
    }
  };

  const handleCreate = () => {
    setCurrentRubro(null);
    setDetRubro('');
    setOpen(true);
  };

  const handleEdit = (rubro) => {
    setCurrentRubro(rubro);
    setDetRubro(rubro.det_rubro);
    setOpen(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('¿Estás seguro de eliminar este rubro?')) {
      try {
        await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/api/rubros/${id}`);
        fetchRubros();
      } catch (error) {
        console.error('Error al eliminar el rubro:', error);
      }
    }
  };

  const handleSubmit = async () => {
    try {
      if (currentRubro) {
        // Editar rubro
        await axios.put(`${process.env.REACT_APP_API_BASE_URL}/api/rubros/${currentRubro.id_rubro}`, { det_rubro });
      } else {
        // Crear rubro
        await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/rubros`, { det_rubro });
      }
      fetchRubros();
      setOpen(false);
    } catch (error) {
      console.error('Error al guardar el rubro:', error);
    }
  };

  return (
    <Container maxWidth="lg">
      <Typography variant="h4" gutterBottom>
        Gestión de Rubros
      </Typography>
      <Button 
        variant="contained" 
        color="primary" 
        startIcon={<AddIcon />} 
        onClick={handleCreate}
        style={{ marginBottom: '20px' }}
      >
        Crear Rubro
      </Button>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Nombre</TableCell>
              <TableCell>Acciones</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rubros.map((rubro) => (
              <TableRow key={rubro.id_rubro}>
                <TableCell>{rubro.det_rubro}</TableCell>
                <TableCell>
                  <IconButton color="primary" onClick={() => handleEdit(rubro)}>
                    <EditIcon />
                  </IconButton>
                  <IconButton color="secondary" onClick={() => handleDelete(rubro.id_rubro)}>
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>{currentRubro ? 'Editar Rubro' : 'Crear Rubro'}</DialogTitle>
        <DialogContent>
          <TextField
            margin="dense"
            label="Nombre del Rubro"
            fullWidth
            value={det_rubro}
            onChange={(e) => setDetRubro(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)} color="primary">
            Cancelar
          </Button>
          <Button onClick={handleSubmit} color="primary">
            Guardar
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
}

export default CrudRubros;
